import { HEADER_IS_APPAREL_RETAILER } from "@faire/retailer-shared/web-api/headers";
import { headerInterceptorFactory } from "@faire/web--source/common/requests/request-interceptors/headerInterceptor";
export var isApparelRetailerInterceptorFactory = function(getIsApparelRetailer) {
    return headerInterceptorFactory({
        header: HEADER_IS_APPAREL_RETAILER,
        value: function() {
            return String(getIsApparelRetailer());
        }
    });
};
